import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Invite a new person with the right role and locations
 * @primary Invite form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/admin/users/invite")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
